import primer from "../primer"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
  ...primer(),

  statusToTrack: "VISIT_CHECKOUT",

  onInit() {
    this.initPrimer({
      checkoutCompletePath: nextStepPath,
    })
  },
})
